/* eslint-disable */
import _ from 'lodash'
import utils from './utils'
import domHelper from './dom'
import storageHelper from './storage'

const VueHelper = {
  install (Vue, options) {
    let helper = _.merge(utils, domHelper, {storage: storageHelper})
    if (options && options.name) {
      Vue[options.name] = helper
      Object.defineProperties(Vue.prototype, {
        [options.name]: { get() { return helper } }
      })
    } else {
      Vue._h = helper
      Object.defineProperties(Vue.prototype, {
        _h: { get() { return helper } }
      })
    }
    Vue.prototype.$h = helper;

    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.use(VueHelper)
    }
  }
}

export default VueHelper



// WEBPACK FOOTER //
// ./src/assets/js/helper/index.js